import Tools from '@/components/tools/Tools.js'
import Alerts from '@/components/forms/Alerts'
import { toast, loading } from '@/shared/utils/UIHelper'
import {mask} from 'vue-the-mask'
import Forms from '@/components/forms/Forms'
import Tables from '@/components/forms/Tables'
import TableColumn from '@/components/forms/TableColumn'
import { JWTService } from '@/shared/services/jwt'
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'actionForms',
  mixins: [ PermissionMixin ],
  data () {
    return {
      roles: Roles,
      data: null,
      form: null,
      objList: null,
      error: null,
      polling: null
    }
  },
  directives: {mask},
  components: {
    Alerts,
    Forms,
    Tables,
    TableColumn
  },
  created () {
  },
  mounted () {
    Tools.MinimizedSidebar()
    this.onClear()
    this.onLoad()
  },
  methods: {
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      window.scrollTo(0, 0)
      loading.pop()
    },
    onSave () {
      var self = this
      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        // Set default data
        this.data.dateUpdate = this.moment().format('YYYY-MM-DDThh:mm:ss')
        this.data.accountIDUpdate = JWTService.GetTokenPayload().AccountID
        if (this.data.hasOwnProperty('companyID')) {
          this.data.companyID = JWTService.GetTokenPayload().companyID
        }
        if (this.data.hasOwnProperty('password')) {
          this.data.password = this.data.password ? this.data.password.toString() : null
        }

        if (this.data) {
          if (this.data.id !== null && this.data.id !== '00000000-0000-0000-0000-000000000000') {
            this.onUpdate()
          } else {
            this.data.id = '00000000-0000-0000-0000-000000000000'
            this.data.status = true
            this.onCreate()
          }
        } else {
          toast.error(this.$lang.Common.NoRecordInformed)
        }
      }
    },
    onSearch () {
      console.log('Warning: Override method in your view implementation onSearch()')
    },
    onLoad () {
      console.log('Warning: Override method in your view implementation onLoad()')
    },
    onCreate () {
      console.log('Warning: Override method in your view implementation onCreate()')
    },
    onUpdate () {
      console.log('Warning: Override method in your view implementation onUpdate()')
    },
    onChange (obj) {
      for (var key in this.data) {
        if (obj.hasOwnProperty(key)) {
          this.data[key] = obj[key]
        }
      }
      if (this.data.status === true) {
        this.data.status = false
      } else {
        this.data.status = true
      }
      this.onUpdate()
    },
    onResultObj (response) {
      if (response.data.code >= 0) {
        return response.data.data
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
        return null
      }
      // loading.pop()
    },
    onResultSimple (response) {
      this.onResult(response, true, true)
    },
    onResult (response, IsNotLoad, IsNotClear) {
      if (response.data.code >= 0) {
        if (!IsNotClear) {
          this.onClear()
        }
        // this.$refs.alert.ShowSuccess()
        toast.success(this.$lang.Common.Alerts.Success)
        if (!IsNotLoad) {
          this.onLoad()
        }
      } else {
        this.$refs.alert.ShowError()
      }
      loading.pop()
    },
    onResultGrid (response, tableGridRef) {
      if (response.data.code >= 0) {
        this.objList = response.data.data
        if (tableGridRef) {
          tableGridRef.LoadAllByData(response)
        } else {
          this.$refs.tableGrid.LoadAllByData(response)
        }
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      }
      loading.pop()
    },
    onStartTotalGrid (tableGridRef, total) {
      tableGridRef.LoadStartTotalGrid(total)
    },
    onException (err) {
      console.log(err)
      if (err.message === 'Unauthorized') {
        toast.error(this.$lang.Common.SessionEnded)
      } else {
        toast.error(this.$lang.Common.MicroserviceUnavailable)
      }
      loading.pop()
    },
    onResultDropdown (response, hasOpt) {
      var result = []
      if (response.data.code >= 0) {
        var data = response.data.data
        for (var i in data) {
          if (data[i].status) {
            if (hasOpt) {
              result.push({ 'text': ' ' + data[i].name, 'value': data[i].id })
            } else {
              result.push({ 'text': data[i].name, 'value': data[i].id })
            }
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      }
      loading.pop()

      return result
    },
    onSetDropdown (data, hasOpt) {
      var result = []

      if (data && data.length > 0) {
        for (var i in data) {
          if (data[i].status) {
            if (hasOpt) {
              result.push({ 'text': ' &nbsp;&nbsp; ' + data[i].name, 'value': data[i].id })
            } else {
              result.push({ 'text': data[i].name, 'value': data[i].id })
            }
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
      }

      return result
    },
    onResultSelect2 (response) {
      var result = []
      if (response.data.code >= 0) {
        var data = response.data.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      }
      loading.pop()

      return result
    },
    onResultAutoComplete (response) {
      var result = []
      if (response.data.code >= 0) {
        var data = response.data.data
        for (var i in data) {
          if (data[i].alias) {
            result.push({ 'text': data[i].alias, 'value': data[i] })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i] })
          }
        }
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      }
      loading.pop()

      return result
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          if (this.permissions[i].role === role) {
            result = true
          }
        }
      }
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/mixins/actionsForm.js